import React, { useState } from "react";
import InputMask from 'react-input-mask';
import Button from "../../../components/Button";
import ModalContent from "../../../components/ModalContent";
import ModalButtons from "../../../components/ModalButtons";
import ToastMessage from "../../../components/ToastMessage";
import {validateField} from "../../../utils/validateField";
import { useNewContact } from "../../../context/contextNewContact";
import { useColorMode } from "../../../context/contextColorMode";

import { FormContact } from "../styles";

const Phone = ({  navigation }) => {
  const [error, setError] = useState(false);
  const {isEnabled} = useColorMode();
  const { phone, setPhone } = useNewContact();

  const { next, previous } = navigation;

  const beforeMaskedValueChange = (newState) => {
    let { value } = newState;

    const newValue = value.replace(/\D/g, "");
    if (newValue.length === 11) {
      value = newValue.replace(/^(\d{2})(\d{5})(\d{4})$/, "($1) $2-$3");
    }

    return {
      ...newState,
      value
    };
  };

  return (
    <>
      {error ? (
        <ToastMessage
          variant="info"
          message="Preencha este campo antes de continuar!"
        />
      ) : null}
      <ModalContent displayFlex={true}>
        <FormContact darkMode={isEnabled}>
          <h2>INFORME AGORA O PRINCIPAL TELEFONE</h2>
          <InputMask
            mask="(99) 9999-99999"
            maskChar={null}
            value={phone}
            placeholder="(00) 00000-0000"
            beforeMaskedValueChange={beforeMaskedValueChange}
            onChange={e=>setPhone(e.target.value)}
          />
        </FormContact>
      </ModalContent>
      <ModalButtons>
        <Button
          bgcolor="var(--blue)"
          color="#fff"
          border="var(--blue)"
          hover="var(--blue-hover)"
          expansive={true}
          hollow={false}
          size="small"
          onClick={async () => {
            await validateField(phone, 'text', next, setError);
            setError(false);
          }}
        >
          CONTINUAR
        </Button>
        <hr />
        <Button
          color="var(--gray)"
          border="var(--gray)"
          expansive={true}
          hollow={true}
          size="small"
          onClick={previous}
        >
          VOLTAR
        </Button>
      </ModalButtons>
    </>
  );
};

export default Phone;
